import Vuex from 'vuex';
import Vue from 'vue';
import createPersistedState from 'vuex-persistedstate';
import modules from './modules';

Vue.use(Vuex);

const store = new Vuex.Store({
    plugins: [
        createPersistedState({key: 'solluti'})
    ],
    modules,
    strict: true,
});

export default store
